import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
import login from "../views/login";
import Detail from "../views/detail/detail.vue";
import Live from "../views/home/live/index.vue";
import Collection from "../views/collection/index.vue";
import Test from "../views/collection/test.vue";
import Datika from "../views/collection/datika.vue";
import Caijima from "../views/collection/caijima.vue";
import Category_res from "../views/collection/category_res.vue";
import Success_tj from "../views/collection/success_tj.vue";
import Shouye from "../views/shouye/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/shouye"
  },
  {
    path: "/shouye",
    name: "Shouye",
    component: Shouye,
  },
  {
    path: "/collection",
    name: "Collection",
    component: Collection,
  },
  {
    path: "/success_tj",
    name: "Success_tj",
    component: Success_tj,
  },
  {
    path: "/caijima",
    name: "Caijima",
    component: Caijima,
  },
  {
    path: "/datika",
    name: "Datika",
    component: Datika,
  },
  {
    path: "/category_res",
    name: "Category_res",
    component: Category_res,
  },
  // {
  //   path: "/test",
  //   name: "Test",
  //   component: Test,
  // },
  // {
  //   path: "/login",
  //   name: "login",
  //   component: login,
  // },
  // {
  //   path: "/live",
  //   name: "live",
  //   component: Live
  // },
  // {
  //   path: "/cslive",
  //   name: "cslive",
  //   component: () => import('../views/home/live/cslive.vue')
  // },
  // {
  //   path: "/videoshow",
  //   name: "videoshow",
  //   component: () => import('../views/home/live/videoshow.vue')
  // },
  // {
  //   path: "/livecs",
  //   name: "livecs",
  //   component: () => import('../views/home/live/livecs.vue')
  // },
  // {
  //   path: "/detail",
  //   name: "detail",
  //   component: Detail,
  //   redirect: '/noticedetail', //页面将默认加载/noticedetail路由对应的组件
  //   children: [
  //     {
  //       path: '/noticedetail',
  //       name: 'noticedetail',
  //       component: () => import('../views/detail/noticedetail')
  //     },
  //     {
  //       path: '/videodetail',
  //       name: 'videodetail',
  //       component: () => import('../views/detail/videodetail')
  //     },
  //     {
  //       path: '/articledetail',
  //       name: 'articledetail',
  //       component: () => import('../views/detail/articledetail')
  //     },
  //     {
  //       path: '/Informationdetail',
  //       name: 'Informationdetail',
  //       component: () => import('../views/detail/Informationdetail')
  //     },
  //     {
  //       path: '/specialdetail',
  //       name: 'specialdetail',
  //       component: () => import('../views/detail/specialdetail')
  //     },
      
  //   ]

  // },


];
const originalReplace = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const router = new VueRouter({
  routes
});

// router.beforeEach((to, from, next) => {
//   if (sessionStorage.getItem('userInfo')) { // 如果已经登录的话
//     next();
//   } else {
//     if (to.path === '/login') { // 如果是登录页面的话，直接next()
//       next();
//     } else { // 否则 跳转到登录页面
//       next({
//         path: '/login'
//       });
//     }
//   }
// });
export default router;
